<template>
	<div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb class="bnone">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/brand.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>短信管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
			status-icon>
			<el-divider content-position="left">短信</el-divider>
			<el-form-item label="短信平台">
				<el-radio-group  v-model="item.engine" >
					<el-radio :label="'cryun'">创瑞</el-radio>
					<el-radio :label="'aliyun'">阿里</el-radio>
				</el-radio-group>
			</el-form-item>

			<template v-if="item.engine == 'cryun'">
				<el-form-item label="Appid">
					<el-input v-model="item.sms_appid" placeholder="请输入Appid"></el-input>
				</el-form-item>
				<el-form-item label="秘钥">
					<el-input v-model="item.sms_key" placeholder="请输入秘钥"></el-input>
				</el-form-item>
				<el-form-item label="签名">
					<el-input v-model="item.sms_sign" placeholder="请输入签名"></el-input>
				</el-form-item>
				<el-form-item label="模板ID">
					<el-input v-model="item.sms_templateid" placeholder="请输入模板ID"></el-input>
				</el-form-item>
			</template>
			<template v-if="item.engine == 'aliyun'">
				<el-form-item label="Appid">
					<el-input v-model="item.ali_sms_appid" placeholder="请输入Appid"></el-input>
				</el-form-item>
				<el-form-item label="秘钥">
					<el-input v-model="item.ali_sms_key" placeholder="请输入秘钥"></el-input>
				</el-form-item>
				<el-form-item label="签名">
					<el-input v-model="item.ali_sms_sign" placeholder="请输入签名"></el-input>
				</el-form-item>
				<el-form-item label="模板ID">
					<el-input v-model="item.ali_sms_templateid" placeholder="请输入模板ID"></el-input>
				</el-form-item>
			</template>
			<el-form-item>
				<el-button type="primary" @click="submit" v-auth="['admin/setting/smsEdit']">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {
					engine: 'cryun'
				},
				isLoad: false,
			}
		},
		created() {
			this.loadItem()
		},
		methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url
				});
				window.open(link.href, '_blank')
			},
			loadItem() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/admin/setting/sms').then(res => {
					this.isLoad = !this.isLoad
					if (res.data.detail) {
						this.item = res.data.detail
						if (!this.item.engine) {
							this.item.engine = 'cryun'
						}
					}
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/admin/setting/smsEdit', {
					form: this.item
				}).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			}
		}
	}
</script>
<style>
</style>
